<template>
  <div class="no-car-carrier-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'NoCarCarrierIndex'
}
</script>

<style lang="less" scoped>
.no-car-carrier-container {
  padding: 20px;
  height: 100%;
}
</style>